import {RouteContext} from "../../RouteContext";
import React from "react";
import {PlaceKeywordDataTransferObject} from "../../../../model/dto/content/place/PlaceKeywordDataTransferObject";
import {PlaceKeywordIO} from "../../../../io/content/place/PlaceKeywordIO";
import { Styles } from "../../common/Styles";
import {InputStringStatePair, StatePair, useError, useInputString, useStatePair} from "../../../../type/States";
import {Button, Field, FieldProps, Input} from "@fluentui/react-components";
import {DataTransferObjectValidation} from "../../../../type/Types";
import {Column, Row} from "../../common/Layout";
import {useParams} from "react-router-dom";


export default function Post(props: RouteContext) {
    const styles = Styles.useEditorStyles()
    const params = useParams<{ id: string }>()

    const inputStates: Record<keyof PlaceKeywordDataTransferObject.Post, InputStringStatePair> = {
        placeId: useInputString(params.id && params.id.toString()!='undefined' ? params.id.toString() : ''),
        keyword: useInputString(''),
        rank: useInputString(''),
    }
    const inputValidationStates: Record<keyof PlaceKeywordDataTransferObject.Post, StatePair<FieldProps['validationState']>> = {
        placeId: useStatePair<FieldProps['validationState']>('none'),
        keyword: useStatePair<FieldProps['validationState']>('none'),
        rank: useStatePair<FieldProps['validationState']>('none'),
    }
    const postErrorState = useError()

    const onDoneClick = () => {
        inputValidationStates.placeId.setValue('none')
        inputValidationStates.keyword.setValue('none')
        inputValidationStates.rank.setValue('none')
        try {
            const dto: PlaceKeywordDataTransferObject.Post = {
                placeId: DataTransferObjectValidation.validate(PlaceKeywordDataTransferObject.Post.validation, 'placeId', inputStates.placeId.value, () => inputValidationStates.placeId.setValue('error')),
                keyword: DataTransferObjectValidation.validate(PlaceKeywordDataTransferObject.Post.validation, 'keyword', inputStates.keyword.value, () => inputValidationStates.keyword.setValue('error')),
                rank: DataTransferObjectValidation.validate(PlaceKeywordDataTransferObject.Post.validation, 'rank', inputStates.rank.value, () => inputValidationStates.rank.setValue('error')),
            }

            PlaceKeywordIO.post(dto)
                .then(() => window.alert('추가되었습니다.'))
                .catch(postErrorState.setDefinedValue)
        } catch (error) {
            console.error(error)
        }
    }

    return <>
        <postErrorState.Dialog {...props} />
        <Column gap={'16px'}>
            <Field
                className={styles.field}
                label={PlaceKeywordDataTransferObject.Post.description.placeId}
                validationState={inputValidationStates.placeId.value}>
                <Input
                    value={inputStates.placeId.value}
                    onChange={inputStates.placeId.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={PlaceKeywordDataTransferObject.Post.description.keyword}
                validationState={inputValidationStates.keyword.value}>
                <Input
                    value={inputStates.keyword.value}
                    onChange={inputStates.keyword.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={PlaceKeywordDataTransferObject.Post.description.rank}
                validationState={inputValidationStates.rank.value}>
                <Input
                    value={inputStates.rank.value}
                    onChange={inputStates.rank.onChange} />
            </Field>
            <Row>
                <Button
                    appearance={'primary'}
                    onClick={onDoneClick}>
                    완료
                </Button>
            </Row>
        </Column>
    </>
}